import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum NotificationProviderTypeEnum {
  CART_DETAILS = 'CART_DETAILS',
  CUSTOMER_DETAILS = 'CUSTOMER_DETAILS',
  COMMON_INFO = 'COMMON_INFO',
  SUMMARY_PRICES = 'SUMMARY_PRICES',
  SLOTS_SERVICE = 'SLOTS_SERVICE',
  PAGE_VALIDATION_CART = 'PAGE_VALIDATION_CART',
  ANALYTICAL_DATA = 'ANALYTICAL_DATA',
  FORM_FIELDS_CONFIGURATION = 'FORM_FIELDS_CONFIGURATION',
  FORM_TEMP_FIELDS_CONFIGURATION = 'FORM_TEMP_FIELDS_CONFIGURATION',
  CONFIG = 'CONFIG'
}

@Injectable()
export class NotificationProviderService {

  private collection: { [id in NotificationProviderTypeEnum]?: any } = {};

  constructor() {}

  public publish(name: NotificationProviderTypeEnum, data: any) {
    const subject = this.getSubject(name);
    subject.next(data);
  }

  public subscribe(name: NotificationProviderTypeEnum, callback: any) {
    const subject = this.getSubject(name);

    return subject.subscribe(callback);
  }

  public getSubject(name: NotificationProviderTypeEnum, data?: any | null): BehaviorSubject<any> {
    return (this.collection[name] || (this.collection[name] = new BehaviorSubject(data)));
  }

  public getValue(name: NotificationProviderTypeEnum) {
    const subject = this.getSubject(name);

    try {
      return subject.getValue();
    } catch (err) {
      return null;
    }
  }
}
